import { render } from "./HeaderTrade.vue?vue&type=template&id=5156d583"
import script from "./HeaderTrade.vue?vue&type=script&lang=js"
export * from "./HeaderTrade.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__